<template>
  <div class="page-wrapper">
    <!-- Modal -->
    <BuyLicence
      v-if="isOpenLicence"
      :show="isOpenLicence"
      v-on:closeLicence="isOpenLicence = false"
      @openBill="getAmt"
      :plans="plans"
    />

    <SubBilling
      v-if="isOpenBilling"
      :show="isOpenBilling"
      v-on:closeLicence="isOpenBilling = false"
      :plans="plans"
      @openPaystack="openPaystack"
    />

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-5 align-self-center mb-2">
          <h6 class="page-title">{{ $t("Subscription") }}</h6>
        </div>
        <div class="col-md-7 align-self-center">
          <div class="d-flex align-items-center justify-content-end">
            <button
              class="btn btn-secondary"
              style="margin-right: 8px;"
              @click="exportPdf(true)"
              v-if="btnExport"
            >
              {{ $t("export-pdf") }}
            </button>
            <button @click="openModalLicence" class="btn btn-primary" v-else>
              {{ $t("buy-licence") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <NotifcationBox :mssg="this.subMsg" :errorMssg="this.SubErrMsg" />

      <div class="page-breadcrumb canvas_div_pdf">
        <div class="row">
          <div class="col-md-12 col-lg-12 align-self-center">
            <ul class="breadcrumb mb-2 list-style-none">
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link class="mylink" to="devices">{{
                  $t("devices")
                }}</router-link>
              </li>
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
              <router-link class="mylink" to="licences">{{ $t("licenses") }}</router-link>
              </li>
              <!-- <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link class="mylink" to="invoices">Invoices</router-link>
              </li> -->
            </ul>
          </div>
        </div>
      </div>

      <!-- 
      <paystack
        :amount="amount"
        :email="email"
        :paystackkey="paystackkey"
        :reference="reference"
        :callback="callback"
        :close="close"
        :embed="false"
      >
        <i class="fas fa-money-bill-alt"></i>
        Make Payment
      </paystack> -->

      <router-view :key="$route.fullPath" />
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- footer -->
    <!-- ============================================================== -->
    <!-- <footer class="footer text-center">
        All Rights Reserved by Gricd Frij.
      </footer> -->
    <!-- ============================================================== -->
    <!-- End footer -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
// import Vue from 'vue';
// import {mapGetters, mapActions} from 'vuex';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapActions, mapGetters } from "vuex";
import NotifcationBox from "../../../components/NotificationBox.vue";
// import vClickOutside from 'v-click-outside';
import BuyLicence from "../../Modals/BuyLicence.vue";
import SubBilling from "../../Modals/SubscriptionBilling.vue";

export default {
  name: "Subscription_",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      isOpen: false,
      mssg: "",
      unitNum: null,
      full_name: "",
      email: "",
      Errormssg: "",
      btnExport: false,
      isOpenLicence: false,
      isOpenBilling: false,
      suibscriptionData: {
        planid: "",
        months: null,
        devices: null,
        amount: null,
      },
    };
  },
  components: {
    Loading,
    NotifcationBox,
    BuyLicence,
    SubBilling,
  },
  methods: {
    ...mapActions([
      "getPlans",
      "getSubscriptions",
      "subscribe",
      "getBusinessProfile",
      "exportPdf",
    ]),
    getAmt({ planid, totalPrice, devices, months }) {
      console.log(totalPrice);
      this.isOpenBilling = true;
      this.isOpenLicence = false;
      this.suibscriptionData = {
        planid,
        devices,
        months,
        amount: totalPrice,
      };
    },
    closeModal() {
      this.isOpen = false;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    openPaystack(email) {
      const { planid, months, devices, amount } = this.suibscriptionData;
      const proceed = (response) => {
        const payload = {
          planid,
          price: amount,
          paystack: response.reference,
          months,
          devices,
        };
        this.isLoading = true;
        this.subscribe(payload).then((res) => {
          this.isLoading = false;
          this.mssg = res.data.message;
          setTimeout(() => {
            this.mssg = "";
          }, 6000);
        });
      };
      let key = "";
      if (window.location.host === "enterprise.gricd.com") {
        key = process.env.VUE_APP_LIVEKEY;
      } else key = process.env.VUE_APP_TESTKEY;
      let handler = PaystackPop.setup({
        key,
        email: email,
        amount: amount * 100,
        ref: "" + Math.floor(Math.random() * 1000000000 + 1),
        onClose: function() {
          // alert("Window closed.");
        },
        callback: function(response) {
          proceed(response);
        },
      });
      handler.openIframe();
    },
    processPayment(response) {
      this.isLoading = true;
      const { planid, months, devices } = this.suibscriptionData;
      const payload = {
        planid,
        price: this.amount,
        paystack: response.reference,
        months,
        devices,
      };
      this.subscribe(payload)
        .then((res) => {
          this.isLoading = false;
          this.mssg = res.data.message;
          setTimeout(() => {
            this.mssg = "";
          }, 6000);
        })
        .catch((err) => console.error(err));
    },
    close() {
      // console.log('close');
    },
    openModal() {
      this.isOpen = true;
      // this.reference();
      this.unitNum = null;
    },
    openModalLicence() {
      this.isOpenLicence = true;
    },
  },
  computed: {
    ...mapGetters(["plans", "subMsg", "SubErrMsg"]),
  },
  mounted() {
    if (this.$route.name === "SubscriptionInvoices") this.btnExport = true;
    this.getPlans();
    this.getSubscriptions().then((res) => console.log(res));
    this.getBusinessProfile();
  },
  watch: {},
  beforeRouteUpdate(to, from, next) {
    switch (to.path) {
      case "/subscription/invoices":
        this.btnExport = true;
        break;
      default:
        this.btnExport = false;
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "WalletDetails") {
      this.$emit("hideWallet");
    }
    next();
  },
};
</script>

<style src="../../../assets/css/style.css"></style>
<style scoped>
.mylink {
  color: #494f54 !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
}
.succeed {
  background: #DEE2EB;
  padding: 10px 15px 1px;
  border: 1px solid #213e7a;
  margin-bottom: 2rem;
}
.succeed p {
  color: #213e7a;
}
.errorMsg {
  background: #f8e2ea;
  padding: 10px 15px 1px;
  border: 1px solid #a8286f;
  margin-bottom: 2rem;
}
.errorMsg p {
  color: #a8286f;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<i18n>
{
	"en": {
		"buy_things": "Buy Units",
		"d_sum": "The sum of",
		"details": "Details",
		"hist": "History",
		"num_of_units": "Number of Units for SMS",
		"paystack": "Pay with Paystack",
		"pls_fill": "Please fill in the number of units you will require per time.",
		"price_unit": "Price per Unit",
		"wallet": "Wallet",
		"wil_b_deduc": "will be deducted from your account",
    "Subscription": "Subscription",
      "export-pdf": "Export PDF",
      "buy-licence": "Buy Licence",
      "Licences":"Licences"
	},
	"es": {
		"buy_things": "Comprar unidades",
		"d_sum": "La suma de",
		"details": "Detalles",
		"hist": "historia",
		"num_of_units": "Número de unidades para SMS",
		"paystack": "Paga con Paystack",
		"pls_fill": "Por favor, complete la cantidad de unidades que necesitará por vez.",
		"price_unit": "precio por unidad",
		"wallet": "billetera",
		"wil_b_deduc": "será deducido de su cuenta"
	},
	"fr": {
		"buy_things": "Acheter des unités",
		"d_sum": "La somme de",
		"details": "Détails",
		"hist": "L'histoire",
		"num_of_units": "Nombre d'unités pour SMS",
		"paystack": "Payer avec Paystack",
		"pls_fill": "Veuillez indiquer le nombre d'unités dont vous aurez besoin par fois.",
		"price_unit": "Prix par unité",
		"wallet": "Portefeuille",
		"wil_b_deduc": "sera déduit de votre compte",
    "Subscription": "Abonnement",
      "export-pdf": "Exporter en PDF",
      "buy-licence": "Acheter une licence",
      "Licences":"Licences"
	},
	"sw": {
		"buy_things": "Nunua Vitengo",
		"d_sum": "Jumla ya",
		"details": "Maelezo",
		"hist": "Historia",
		"num_of_units": "Idadi ya Vitengo vya SMS",
		"paystack": "Lipa kwa Paystack",
		"pls_fill": "Tafadhali jaza idadi ya vitengo utakavyohitaji kwa wakati.",
		"price_unit": "Bei kwa kila Kitengo",
		"wallet": "Mkoba",
		"wil_b_deduc": "itakatwa kutoka kwa akaunti yako",
    "Subscription": "Michango",
      "export-pdf": "Chapisha kwa PDF",
      "buy-licence": "Nunua Leseni",
      "Licences":"Leseni"
	}
}
</i18n>
